export function smartGoByStatus(status) {
  const query = `{
      smartGoByStatus(status: "${status}"){
          id, 
          requestId,
          student{id, fullName, classesNames, profilePhotoUrl},
          status,
          responsible{id, fullName},
          driveMode,
          startType,
          timeToGet, 
          lastLocationUpdate,
          creationDateMs,
          distance,
          arrivalEstimate,
          arrived,
          inRadius
          entry{itemNote{shortName}, responsible{fullName}, hourNote},
          updaterName,
          updatedAtMs
      }
  }`;
  return query;
}

export function smartGoPendencyQuantity() {
  const query = '{smartGoPendencyQuantity{pendencyQuantity}}';
  return query;
}

export function saveSmartGoMutation(values) {
  let entry;
  if (values.statusAccess) {
    entry = {
      idenItem: values.statusAccess,
      idResponsible: values.smartcard.responsibleId,
      idItemNote: 0,
      firstLevelItemCode: 0,
      dateNote: 0,
      valueNote: 0,
      id: 0,
      idStudent: 0,
      createEmployeeId: 0,
    };
  }
  const mutationQuery = `mutation {
    smartGoUpdateStatus(
      smartGo: {
        id: ${values.smartcard.id ? values.smartcard.id : 0}, 
        status:"${values.smartStatus}", 
        distance: ${values.smartcard.distance}
        requestId: ${
          values.smartcard.requestId ? values.smartcard.requestId : 0
        },
        ${
          entry
            ? `entry: ${JSON.stringify(entry).replace(/"([^(")"]+)":/g, '$1:')}`
            : ''
        }
        student:{
          id:${values.smartcard.studentId}, 
          filterByStatus: false, 
          updaterId: 0, 
          active: true, 
          legacyId:0, 
          dateOfBirth:0
          activeOnLoggedPeriod: false
        },
        filterByStatus: false
        updaterId: 0
        creationDateMs: 0
        lastLocationUpdate: 0
        pendencyQuantity: 0
        timeToGet: 0
        updatedAtMs: 0
      }
    )
  }`;
  return mutationQuery;
}
